import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, MenuItem, Menu, ListItemIcon, Divider} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { HeaderStyle } from './Header.style';
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import WarningIcon from '@material-ui/icons/WarningRounded';
import AddIcon from '@material-ui/icons/AddRounded';
import { ISuggestion, ICreateSuggestion, IScheduleChange } from '@app-types/websocket/suggestion.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { ISchedule, IScheduleName } from '@app-types/websocket/schedule.types';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import { FamilyMemberType } from '@services/family/family.constants';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import * as UserActions from '@services/user/user.actions';
import * as SuggestionActions from '@services/suggestion/suggestion.action';
import { grayColor, secondaryColor, styleColors } from 'src/main.style';
import ScheduleItem from './ScheduleItem';
import { SUGGESTION_TYPES } from '@constants/suggestionTypes';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  subMenuRef:HTMLDivElement|null;
  open:boolean;
}

interface IProps extends WithStyles<typeof HeaderStyle> {
  suggestions:ISuggestion[];
  userId:number;
  family:IFamilyMember[];
  schedules:ISchedule[];
  calendarSettings: ICalendarSetting;
  isEditing:boolean;

  totalSentSuggestionsNonActive:number;
  totalReceivedSuggestionsNonActive:number;
  usedByErrorSchedules:number[];

  startEditing:(scheduleId:number, suggestionId:number|undefined) => void;
  startGuide:(scheduleId:number) => void;
  close:() => void;

  updateCalendarSettings: (data: ICalendarSetting) => void;
  createSuggestion: (data: ICreateSuggestion) => void;
  suggestEditing:(scheduleId:number, suggestionId:number|undefined) => void;
  changeName:(scheduleId:number, scheduleName:string) => void;
  createNewSchedule: () => void;
  showDetails:(suggestion:ISuggestion) => void;
}

class SchedulesMenu extends React.Component<IProps, IState> {

  private moreSchedRef: React.RefObject<HTMLDivElement>;

  constructor(props: IProps) {
    super(props);


    this.state = {
      subMenuRef:null,
      open:false,
    };

    this.moreSchedRef = React.createRef();

  }



  public render() {
    const {classes, suggestions, userId, family, calendarSettings, schedules} = this.props;

    const suggestionsCounter = {};
    const menu:JSX.Element[] = [];
    const otherSchedules:JSX.Element[] = [];

    let myRole:FamilyMemberType = FamilyMemberType.VIEWER;

    const primarySchedules:number[] = (calendarSettings !== undefined && calendarSettings.calendars !== undefined)
      ?[...calendarSettings.calendars]
      :[];   
    
    const secondarySchedules:ISchedule[] = [];

    for (const mem of family) {
      if (mem.role === FamilyMemberType.PARENT) {
        if (mem.calendars) {
          for (const cal of mem.calendars) {
            if (!primarySchedules.includes(cal)) {
              primarySchedules.push(cal)
            }
          }
        }
      }
      if (mem.id === userId) {
        myRole = mem.role;
      }
    }

    for (const sched of schedules) {
      if (sched.status !== SCHEDULE_TYPES.DELETED && sched.status !== SCHEDULE_TYPES.DELETED_WIP && !primarySchedules.includes(sched.id)) {
        if (this.props.usedByErrorSchedules.includes(sched.id)) { // this is a new schedule!
          primarySchedules.push(sched.id)
        } else {
          secondarySchedules.push(sched);
        }
      }
    }

    if (myRole === FamilyMemberType.PARENT) {
      for (const sugg of suggestions) {
        if (sugg.status === SUGGESTION_TYPES.AWAITING_APPROVAL) {
          for (const s of sugg.schedules) {
            if (sugg.creatorId === userId) {
              const key = "s"+s;
              const current:number = suggestionsCounter[key]?suggestionsCounter[key]:0;
              suggestionsCounter[key] = current+1
            } else {
              const key = "r"+s;
              const current:number = suggestionsCounter[key]?suggestionsCounter[key]:0;
              suggestionsCounter[key] = current+1
            }
          }
        }
      }
    }

    if (myRole === FamilyMemberType.PARENT){
      menu.push(this.renderCreateNewSchedule());
    }

    if (secondarySchedules.length > 0) {
      menu.push(<Divider key="divider2"/>);
    }

    // render primary schedules directly in menu
    for ( const schedId of primarySchedules) {
      const foundSchedule = schedules.find((sched) => sched.id === schedId);
      if (foundSchedule) {
        menu.push(<ScheduleItem
          key={schedId}
          numSentSuggestions={suggestionsCounter[("s"+schedId)]}
          numReceivedSuggestions={suggestionsCounter[("r"+schedId)]}
          isEditing={this.props.isEditing}
          schedule={foundSchedule}
          usedByErrorSchedules={this.props.usedByErrorSchedules}
          myRole={myRole}
          close={() => this.close()}
          startGuide={(sid:number) => this.props.startGuide(sid)}
          startEditing={(sid:number, sug:number) => this.props.startEditing(sid,sug)}
          suggestEditing={this.props.suggestEditing}
          changeName={this.props.changeName}
          showDetails={(suggestion) => this.props.showDetails(suggestion)}
        />);
      } else {
        menu.push(this.renderHiddenScheduleItem(schedId));
      }
    }


    if (secondarySchedules.length > 0) {
      menu.push(<Divider key={"div3"} />);
    }

    for ( const sched of secondarySchedules) {
      menu.push(<ScheduleItem
        key={sched.id}
        numSentSuggestions={suggestionsCounter[("s"+sched.id)]}
        numReceivedSuggestions={suggestionsCounter[("r"+sched.id)]}
        isEditing={this.props.isEditing}
        schedule={sched}
        usedByErrorSchedules={this.props.usedByErrorSchedules}
        myRole={myRole}
        close={() => this.close()}
        startEditing={(sid:number, sug:number) => this.props.startEditing(sid,sug)}
        startGuide={(sid:number) => this.props.startGuide(sid)}
        suggestEditing={this.props.suggestEditing}
        changeName={this.props.changeName}
        showDetails={(suggestion) => this.props.showDetails(suggestion)}
      />);

    }

    const mainEntry:JSX.Element = this.renderMain(this.props.usedByErrorSchedules.length > 0);

    return (<>

      {mainEntry}

      <Menu // other schedules e.g. private etc
        anchorEl={this.moreSchedRef.current}
        getContentAnchorEl={null}
        open={this.state.open}
        anchorReference="anchorEl"
        onClose={() => this.setState({open:false})}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        transformOrigin={{vertical: 'top', horizontal: 'center'}}
        classes={{
          paper: classes.menuPaper,
          list: classes.menuList,
        }}
      >
        {menu}
      </Menu>
      
    </>);
  }

  private close() {
    this.setState({open:false, subMenuRef:null})
    this.props.close();
  }

  private renderMain(highlightSubMenu:boolean) {
    return (<MenuItem key={"main"}
      disabled={this.props.isEditing}
      className={this.props.classes.menuListItem}
      onClick={() => this.setState({open:!this.state.open})}>
      <div className={this.props.classes.menuItemTitle}>
        <span style={{display: 'flex', alignItems: 'center'}}>
          {tn.lang.calParentingSchedules}
          <span style={{display: 'flex', alignItems: 'center', marginLeft:'3px'}}>
            <span style={{backgroundColor:grayColor}} className=
              {this.props.classes.suggestionBadge
              +(this.props.totalSentSuggestionsNonActive < 1?(" "+this.props.classes.hiddenBadge):"")}>
                {this.props.totalSentSuggestionsNonActive}
            </span>
            <span style={{backgroundColor:secondaryColor}} className={this.props.classes.suggestionBadge
              +(this.props.totalReceivedSuggestionsNonActive < 1?(" "+this.props.classes.hiddenBadge):"")}>
                {this.props.totalReceivedSuggestionsNonActive}
            </span>
            {highlightSubMenu
              ?<span style={{backgroundColor:styleColors.handoverYellow}} className={this.props.classes.suggestionBadge} />
              :null}
          </span>
        </span>
      </div>
      <div className={this.props.classes.menuItemEnd} ref={this.moreSchedRef}>
        <ArrowRightIcon />
      </div>
    </MenuItem>);
  }

  private renderCreateNewSchedule() {
    const {classes} = this.props;

    return(
      <MenuItem className={classes.menuListItem} key={"createnew"} disabled={this.props.isEditing}
        onClick={() => {this.props.createNewSchedule(); this.close();}}>
        <ListItemIcon>
          <AddIcon />
        </ListItemIcon>
        <div className={classes.menuItemTitle}>{tn.lang.calMakeNew}</div>
      </MenuItem>);
  }

  private renderHiddenScheduleItem(schedId:number) {
    const {classes, family} = this.props;

    const usedBy:number[] = [];
    for (const mem of family) {
      if (mem.calendars && mem.calendars.includes(schedId)) {
        usedBy.push(mem.id);
      }
    }

    return (<MenuItem className={classes.menuListItem} disabled={!usedBy.includes(this.props.userId)} key={schedId}
      onClick={() => {this.inactivateSchedule(schedId); this.close();}}>
      <ListItemIcon>
        <WarningIcon />
      </ListItemIcon>
      <div>
        <div className={classes.menuItemTitle}>{tn.lang.scheduleNameNew(undefined)}</div>
        <div className={classes.menuItemTime}>{tn.lang.selectedAsActiveBy(tn.familyMemberNames(usedBy,family))}</div>
        {usedBy.includes(this.props.userId) && <div className={classes.menuItemTitle}>{tn.lang.calStopUsing}</div>}
      </div>
    </MenuItem>
    );
  }

  private inactivateSchedule(scheduleId:number,) {
    const calSettings = this.props.calendarSettings;
    if (calSettings) {
      const settingsCopy:ICalendarSetting = JSON.parse(JSON.stringify(calSettings));
      if (settingsCopy.calendars !== undefined && settingsCopy.calendars.includes(scheduleId)) {
        settingsCopy.calendars = settingsCopy.calendars.filter((sId) => sId !== scheduleId);
      }
      this.props.updateCalendarSettings(settingsCopy);
    }
  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const suggestions:ISuggestion[] = state.suggestion.suggestions?state.suggestion.suggestions:[];
  const schedules:ISchedule[] =  state.schedule.schedules;
  const calendarSettings: ICalendarSetting = state.user.calendarSettings;


  return {
    userId,
    suggestions,
    family: state.family.family,
    schedules,
    calendarSettings,
  };
}


const mapDispatchToProps = {
  updateCalendarSettings:UserActions.updateCalendarSettings,
  createSuggestion: SuggestionActions.createSuggestion,
};

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(HeaderStyle)(SchedulesMenu));



// WEBPACK FOOTER //
// ./src/components/calendar2/header/SchedulesMenu.tsx